<template>
  <div class="account-fav">
    <div class="container">
      <Title>Mes favoris</Title>
    </div>
    <RecipeGrid :recipes="recipes" />
  </div>
</template>

<script>
import Title from "@/components/ui/Title.vue";
import RecipeGrid from "@/components/listing/RecipeGrid.vue";
import UserStore from "@/store/userStore";
import fetchApi from "@/mixins/fetchApi";

export default {
  components: { RecipeGrid, Title },
  data() {
    return {
      recipes: [],
    };
  },
  created() {
    this.fetchFavorites();
  },
  methods: {
    async fetchFavorites() {
      const auth = await this.waitForAuth();
      if (!auth) {
        this.goToLogin();
      }
      if (this.$store.state.recipes.length >= 1) {
        this.recipes = this.$store.state.recipes.filter((recipe) => {
          return (
            UserStore.state.favorites &&
            UserStore.state.favorites.includes(recipe.id)
          );
        });
      } else {
        const response = await fetchApi.get("user/favorites/");
        if (response.status !== 200) {
          this.goToLogin();
        } else {
          this.recipes = response.data;
        }
      }
    },

    goToLogin() {
      this.$router.push("/login?redirect=favorites");
    },
  },
};
</script>
<style lang="scss">
.account-fav {
  margin-top: 20px;
}
</style>
